/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 13:43:16
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ label = [], list = [], color = [], title }) => {
  return {
    title: {
      text: title,
      top: 10,
      textAlign: 'center',
      textStyle: {
        color: '#000',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      show: false,
    },
    grid: {
      left: 50,
      right: 0,
      bottom: 40,
      containLabel: false
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLabel: {
        ...xAxisLabelColor,
        fontWeight: 'bold',
        fontSize: 16,
      },
      axisLine: { show: false },
      axisTick: { show: false },
      minorTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      axisLabel: { ...yAxisLabelColor },
      type: 'value',
      max: 100,
    },
    series: list.map(({ title, list }, index) => {
      return {
        stack: 'same',
        name: title,
        barMaxWidth: 30,
        label: {
          show: true,
          formatter: '{a},{c}%',
        },
        data: list.map((value, _index) => {
          const colorRow = color[_index] || []
          const iColor = colorRow[index]
          const itemStyle = iColor ? { color: iColor } : undefined
          return {
            value,
            itemStyle
          }
        }),
        type: 'bar',
      }
    }).reverse(),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P20/chart.js